import { gql } from "@apollo/client";

export default gql`
  query GetPageContent($id: ID!) {
    page(where: { id: $id }) {
      title
      content {
        html
      }
      seo {
        title
        description
        keywords
      }
    }
  }
`;
